import { AccountPage } from '../AccountPage.jsx';

export function AccountHomePage() {
  return <AccountPage />;
}
